import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class DealService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_API_URL}/deal/`;

}
